<div class="wrap" *ngIf="currentRoute$ | async as currentRoute">
  <app-svg-icon
    (click)="onNavigate('scan')"
    [name]="'scan'"
    [color]="
      (currentRoute | containsSubstrOf : scanRelatedRoutes)
        ? 'color-primary'
        : 'color-neutral-1'
    "
    class="icon"
    [class.active]="currentRoute | containsSubstrOf : scanRelatedRoutes"
  ></app-svg-icon>

  <app-svg-icon
    *ngIf="permissionService.has(permissions.ORDER_DELIVERY) | async"
    (click)="onNavigate('store')"
    [name]="'kitchen-menu'"
    [color]="
      (currentRoute | containsSubstrOf : storeRelatedRoutes)
        ? 'color-primary'
        : 'color-neutral-1'
    "
    class="icon"
    [class.active]="currentRoute | containsSubstrOf : storeRelatedRoutes"
  ></app-svg-icon>

  <div
    (click)="onNavigate('cart')"
    class="cart icon"
    [class.active]="currentRoute | containsSubstrOf : orderRelatedRoutes"
  >
    <app-svg-icon
      [name]="'cart'"
      [color]="
        (currentRoute | containsSubstrOf : orderRelatedRoutes)
          ? 'color-primary'
          : 'color-neutral-1'
      "
      class=""
    ></app-svg-icon>
    <div *ngIf="(cartAmount$ | async)! > 0" class="cart-amount">
      {{ cartAmount$ | async }}
    </div>
  </div>

  <app-svg-icon
    (click)="onNavigate('access-control')"
    [name]="'access-control'"
    [color]="
      currentRoute === 'access-control' ? 'color-primary' : 'color-neutral-1'
    "
    class="icon"
    [class.active]="currentRoute === 'access-control'"
  ></app-svg-icon>

  <app-svg-icon
    (click)="onNavigate('orders')"
    [name]="'user'"
    [color]="
      (currentRoute | containsSubstrOf : orderListRelatedRoutes)
        ? 'color-primary'
        : 'color-neutral-1'
    "
    class="icon"
    [class.active]="currentRoute | containsSubstrOf : orderListRelatedRoutes"
  ></app-svg-icon>
</div>
